// @ts-nocheck
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  // Header Index Style
  rootHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #ccc',
  },
  buttonBox: {
    display: 'flex',
    marginBottom: '8px',
    gap: '8px',
  },
  draftButton: {
    minWidth: 170,
    fontSize: '14px',
    display: 'flex ',
    justifyContent: 'space-around',
  },
  // Preview Index Style
  previewButton: {
    border: '1px solid #ccc',
    padding: '5px',
  },
  logoBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
  },
  card: {
    border: '1px solid #ccc',
    width: 800,
    marginBottom: theme.spacing(2),
  },
  previewContent: {
    wordBreak: 'break-word',
    backgroundColor: '#f5f5f5',
  },
  previewCard: {
    marginTop: '15px',
    border: '1px solid #ccc',
    marginBottom: theme.spacing(2),
    '& .MuiTypography-body1': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '1.5',
    },
  },
  uhOhText: {
    fontSize: '1.2rem',
    color: '#888',
    padding: '2rem 0',
  },
  sectionCard: {
    border: 'none',
  },
}));
